import { CalDateInfo, SlotInfo } from '../../../types/schedule.types';
import { SceneInfo } from '../../../types/scene.types';
import { getCalendarDayRowOrderedIds } from '../../../utils/calDateSlotsSortUtils';

export function formatDateToString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function calDateDtToLocalStr(dt: string | undefined): string {
  if (!dt) return '';
  return dt.split('T')[0];
}

export function getDateSlots(dateStr: string, optimisticSlots: SlotInfo[]): SlotInfo[] {
  return optimisticSlots.filter((slot) => {
    if (!slot.slotDate) return false;
    const slotDateStr = slot.slotDate.split('T')[0];
    return slotDateStr === dateStr;
  });
}

export function getDateCalDate(dateStr: string, optimisticCalDates: CalDateInfo[]): CalDateInfo | undefined {
  return optimisticCalDates.find((pd) => {
    if (!pd.calDateDt) return false;
    const pdDateStr = pd.calDateDt.split('T')[0];
    return pdDateStr === dateStr;
  });
}

export function getCalendarRowIdsForDateStr(
  dateStr: string,
  optimisticSlots: SlotInfo[],
  optimisticCalDates: CalDateInfo[],
  getSceneInfo: (sceneID: string | undefined) => SceneInfo | undefined,
): string[] {
  const pd = getDateCalDate(dateStr, optimisticCalDates);
  return getCalendarDayRowOrderedIds(
    optimisticSlots,
    pd?.calDateSlotsSort,
    dateStr,
    (sceneId) => {
      const s = getSceneInfo(sceneId);
      return s ? { sceneLocation: s.sceneLocation } : undefined;
    },
  );
}
